import { render, staticRenderFns } from "./DocumentInstructions.vue?vue&type=template&id=1c57dcfe&scoped=true"
import script from "./DocumentInstructions.vue?vue&type=script&lang=js"
export * from "./DocumentInstructions.vue?vue&type=script&lang=js"
import style0 from "./DocumentInstructions.vue?vue&type=style&index=0&id=1c57dcfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57dcfe",
  null
  
)

export default component.exports